import { ChangeDetectorRef, Component, Input, input, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule, DatePipe, NgFor, NgIf } from '@angular/common';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    FormsModule,
    NgModel,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import {
    NgbDateStruct,
    NgbDatepicker,
    NgbDatepickerModule,
    NgbInputDatepicker,
    NgbPopoverModule,
} from '@ng-bootstrap/ng-bootstrap';
import { InputsModule, PopoverModule } from 'angular-bootstrap-md';
import {
    BsDatepickerConfig,
    BsDatepickerDirective,
    BsDatepickerModule,
} from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TimepickerConfig, TimepickerModule } from 'ngx-bootstrap/timepicker';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { sessiondaytimeslotsService } from 'app/services/session-day-time-slots';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { TimeZone } from 'timezones-list';
import { CcPaymentsComponent } from '../cc-payment/cc-payment.component';
import { NgxLoadingModule } from 'ngx-loading';
import { provideMatDynamicFormsWithDefaultFeatures } from '@dynamic-forms/material';
import {
    DynamicFormComponent,
    DynamicFormDefinition,
    withDynamicFormColors,
} from '@dynamic-forms/core';
import { MatNativeDateModule } from '@angular/material/core';
import { Util } from 'app/util';
import { MatDialog } from '@angular/material/dialog';
import { EventService } from 'app/services/event.service';
import { ErrorPageComponent } from '../error-page/error-page.component';
import { AccountService } from 'app/services/account.service';
import { SnackbarService } from 'app/services/snackbar.service';
import {
    SearchCountryField,
    CountryISO,
    PhoneNumberFormat,
    NgxIntlTelInputModule,
} from 'ngx-intl-tel-input';
import { BookingSuccessComponent } from '../booking-success/booking-success.component';
import { availableSlot, NewSlotUi, Slot, SlotUI } from 'app/models/slots.model';
import { FuseAlertComponent } from '@fuse/components/alert';
import { MatTooltip } from '@angular/material/tooltip';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LollySchedulerService } from 'app/services/lolly-scheduler.service';
import { BookingPageService } from 'app/services/booking-page.service';
import { BookingService } from 'app/services/bookings.service';
import { BookingPage, BookingPageView, getAvailableTimeSlotsPayload } from 'app/models/booking-page.model';
import { bookingSavePayload, bookingSuccessInput, bookingSuccessResponse, scheduledSession, scheduledSessionPayment } from 'app/models/bookings.model';
import { LottieComponent, LottieDirective } from 'ngx-lottie';
import { LOTTIE_OPTIONS } from 'ngx-lottie/lib/symbols';
import { ReCaptchaV3Service, RecaptchaV3Module } from 'ng-recaptcha';
import { LawpayService } from 'app/services/lawpay.service';
import { formatInTimeZone } from 'date-fns-tz';

const colors = {
    colors: {
        inputAction: 'none',
    },
    libraryName: 'material',
};

const features = [withDynamicFormColors(colors)];
@Component({
    selector: 'app-session-booking',
    standalone: true,
    providers: [
        provideMatDynamicFormsWithDefaultFeatures(
            { theme: 'material' },
            ...features
        ),
        BsDatepickerConfig,
        TimepickerConfig,
        NgbDatepickerModule,
        BsDatepickerDirective,
        BsDatepickerModule,
        NgbDatepickerModule,
        PopoverModule,
        NgbDatepicker,
    ],
    imports: [
        CommonModule,
        FormsModule,
        NgFor,
        NgIf,
        CcPaymentsComponent,
        PopoverModule,
        TimepickerModule,
        FuseAlertComponent,
        ReactiveFormsModule,
        MatNativeDateModule,
        DynamicFormComponent,
        BookingSuccessComponent,
        BsDatepickerModule,
        BsDropdownModule,
        BsDatepickerModule,
        NgxIntlTelInputModule,
        MatStepperModule,
        MatSelectModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatCheckboxModule,
        ErrorPageComponent,
        NgbDatepicker,
        NgbInputDatepicker,
        NgbPopoverModule,
        NgbDatepickerModule,
        NgxLoadingModule,
        MatTooltip,
        FormsModule,
        ReactiveFormsModule,
        LottieComponent,
        LottieDirective,
        RecaptchaV3Module
        
    ],
    templateUrl: './session-booking.component.html',
    styleUrl: './session-booking.component.scss',
})
export class SessionBookingComponent {
    @ViewChild('dp', { static: false }) datePicker: NgbDatepicker;
    @ViewChild(CcPaymentsComponent) ccpayments: CcPaymentsComponent;
    @ViewChild(MatStepper) stepper: MatStepper;
    @ViewChild(DynamicFormComponent) dynamicForm!: DynamicFormComponent;

    minDate: NgbDateStruct;
    maxDate: NgbDateStruct = { year: 2050, month: 12, day: 15 };

    bookingPage: BookingPage = new BookingPage();
    selectedDate: string;
    loading = false;
    spinner: boolean = false;
    availableTimeSlots: availableSlot[] = [];
    timeSlotsUI: NewSlotUi[] = [];
    selectedSlot: SlotUI = new SlotUI();
    bookingData: bookingSavePayload = new bookingSavePayload();
    dayOfWeek: number = 0;
    isPaymentFormValid: boolean = false;
    slot_form: FormGroup;
    personal_details_form: FormGroup;
    intake_form: FormGroup;

    definition: DynamicFormDefinition = null;
    model: any;
    timeZone: string = 'Asia/Karachi';
    error: string = '';
    accountData: { account_name: string };
    bookingSuccess: boolean = false;
    hideBooking: boolean = false;
    vgsForm;
    vgsState;
    payment: scheduledSessionPayment = new scheduledSessionPayment();
    allBooked: boolean = false;
    bookingSlotTime: string = null;
    subs: Subscription = new Subscription();
    bookingStepsCount:number = 4;
    bookingSteps = { slot: true, clientDetail: true, intake: true, payment: true }
    conflict_slots = null;

    separateDialCode = false;
    SearchCountryField = SearchCountryField;
    CountryISO = CountryISO;
    PhoneNumberFormat = PhoneNumberFormat;
    preferredCountries: CountryISO[] = [
        CountryISO.UnitedStates,
        CountryISO.UnitedKingdom,
    ];
    weekSlots = []
    maxSlotsCount:number = 0;
    BookingView : BookingPageView = 'WEEK';
    bookingSuccessInput: bookingSuccessInput = new bookingSuccessInput();
    bookingPageId = null;


    //Captcha
  	captchaSuccess = false;
  	captchaResponse?: string;

    public timeZones: { value: string; label: string }[] = [];
    public browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
    public selectedTimeZone : any  = this.browserTZ;
    public isLastIndex = false;

    constructor(
        private _accountService: AccountService,
        private _bookingPageService: BookingPageService,
        private _bookingService: BookingService,
        private _cdr: ChangeDetectorRef,
        private _eventService: EventService,
        private _lollySchedulerService: LollySchedulerService,
        private _snackBarService: SnackbarService,
        private datePipe: DatePipe,
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private util: Util,
        public sdtsService: sessiondaytimeslotsService,

        private recaptchaV3Service: ReCaptchaV3Service,
        private lawpayService : LawpayService
    ) {
        this.setMinDatePicker();
        this.intake_form = this.fb.group({
            validated: [null, Validators.required] // Dummy field to control validity
        });

        this.model = {};
    }

    ngOnInit(): void {
        this.initTimeZones();
        this.loadBookingPage();

        this.slot_form = this.fb.group({
            selectedSlot: [null, Validators.required],
            calenderSelectedDate: [this.getTodayDate(), Validators.required],
        });

        // Update personal_details_form to use the custom phone validator
        this.personal_details_form = this.fb.group({
            clientFirstName: [null, Validators.required],
            clientLastName: [null, Validators.required],
            clientEmail: [null, [Validators.required, Validators.email]],
            notes: [],
            phone: [
                null,
                [
                    Validators.required,
                    (control: AbstractControl) => this.phoneValidator(control),
                ],
            ],
        });

    }

    ngAfterViewInit(): void {
        this.stepper.selectedIndex = 0;
    }


    initTimeZones() {
        let zones = Intl.supportedValuesOf('timeZone');
        // Ensure browser timezone exists
        if (this.browserTZ && !zones.includes(this.browserTZ)) {
            zones = [this.browserTZ, ...zones];
        }

        // Ensure UTC exists
        if (!zones.includes('UTC')) {
            zones = ['UTC', ...zones];
        }

        // Remove duplicates
        zones = Array.from(new Set(zones));
        this.timeZones = zones.map(tz => ({ value: tz, label: tz === 'UTC' ? 'UTC (GMT+00:00)' : `${tz} (GMT${formatInTimeZone(new Date(), tz, 'XXX')})` }));

        // Default selection
        this.selectedTimeZone = this.timeZones.find(t => t.value === this.browserTZ) ?? this.timeZones.find(t => t.value === 'UTC');
    }

    loadBookingPage() {
         this.bookingPageId = this.route.snapshot.paramMap.get('id');

        this._bookingPageService.getById(this.bookingPageId)
            .then((res: any) => {
                if (res.status === 'ERROR') {
                    this.bookingPageLoadErrorHandler(res?.error);
                    return;
                }
                this.bookingPage = this._bookingPageService.getData(res);

                this.setDynamicFormData();
                this.setBookingSteps()
                this.onDateSelect();
                this.getAccountData();
                this.BookingView = this.bookingPage.accountSession?.calendar_view ?? 'DAY';
            })
            .catch((error) => {
               this.bookingPageLoadErrorHandler(error)
            });
    }

    phoneValidator(control: AbstractControl): ValidationErrors | null {
        const value = control.value;
        // Let required validator handle empty value
        if (!value) {
            return null;
        }
        let number = '';
        let countryCode = '';

        if (typeof value === 'object') {
            // ngx-intl-tel-input might return an object with various keys.
            number = value.nationalNumber || value.number || '';
            countryCode = value.countryCode || value.dialCode || '';
        } else if (typeof value === 'string') {
            number = value;
            countryCode = 'US';
        }

        const digits = number.toString().replace(/\D/g, '');
        if (value.countryCode === 'US' || countryCode === '+1') {
            console.log('inside -' + value.countryCode);
            const digits = value.number.toString().replace(/\D/g, '');
            console.log('digits - ' + digits + ' - length - ' + digits.length);
            if (digits.length === 10) {
                return null;
            } else if (digits.length === 11 && digits.startsWith('1')) {
                return null;
            } else {
                return { validatePhoneNumber: true };
            }
        }
        return null;
    }

    loadConflictSlots(){
        return new Promise((resolve,reject)=>{
            const userId = Number(this.bookingPage.accountSession.conflict_ref_id) 
            const dateString = this.selectedDate
            const date = new Date(dateString);
            
            // Format it in local time
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JS
            const day = String(date.getDate()).padStart(2, '0');
            
            const formattedDate = `${year}-${month}-${day}`;
            if(userId){
                this._lollySchedulerService.getConflictSlots({userId,date:formattedDate}).then(res=>{
                    resolve(res)
                }).catch(error=>{
                    resolve(null)
                })
            }
            else{
                resolve(null)
            }
             
        })
    }

    async onDateSelect(flag?: 'prev' | 'next'): Promise<void> {
        try {
            this.selectedSlot = new SlotUI();
    
            let dateToUse: Date;
    
            // If flag is passed, modify current selected date
            if (flag && this.selectedDate) {
                
                const current = new Date(this.selectedDate); 
                if (flag === 'prev') {
                    
                    current.setDate(current.getDate() - 7);
                } else if (flag === 'next') {
                    current.setDate(current.getDate() + 7);
                }
                dateToUse = current;
                    const year = current.getFullYear()
                    const month = current.getMonth() + 1
                    const todayDateStruct: NgbDateStruct = {
                        year: year,
                        month: month,
                        day: current.getDate(),
                    };
                    this.datePicker.navigateTo({year, month})
                this.slot_form.patchValue({ calenderSelectedDate: todayDateStruct }); 
                this.slot_form.updateValueAndValidity()
            } else {
                // Extract day, date, month, and year
                const { day, month, year } = this.getSelectedDateValue();
                dateToUse = new Date(year, month - 1, day); // Month is 0-indexed
            }
    
            this.selectedDate = this.datePipe.transform(dateToUse, 'longDate');
            this.dayOfWeek = dateToUse.getDay();
    
            // Adjust dayOfWeek to 1–7 (Mon–Sun)
            if (this.dayOfWeek === 0) {
                this.dayOfWeek = 7;
            }
    
            // Load conflict slots and then get available slots
            this.loadConflictSlots().then((res: any) => {
                this.conflict_slots = res?.data ?? [];
                this.getAvailableSlots(this.dayOfWeek, this.selectedDate);
            });
    
        } catch (error) {
            console.error('Error fetching available time slots:', error);
        }
    }
    
    getAvailableSlots(dayId: number,currentDate: string) {
        const accountSessionId =  this.bookingPage.accountSession.uuid;
        this.loading = true;
        const timeZone = this.selectedTimeZone?.value || this.getlocalZone();

        // Parse currentDate string (e.g., "May 20, 2025") into a Date object
        // Parse currentDate (e.g., "May 20, 2025")
        const startDate = new Date(currentDate);
        const endDate = new Date(startDate);
        if (this.BookingView == 'WEEK') {
            endDate.setDate(startDate.getDate() + 6); // 7-day range
        }
        else
            endDate.setDate(startDate.getDate())

        // Format as "May 20, 2025"
        const formatDate = (date: Date) =>
            date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
            });

        const payload :getAvailableTimeSlotsPayload  = {
            sessionUuid: accountSessionId,
            dayId:dayId,
            startDate: formatDate(startDate),
            endDate:formatDate(endDate),
            userTimeZone:timeZone,
            activityDates:this.conflict_slots
        }
      
        const url = `/available-slots`;
        this.sdtsService
            .getSlots(payload,url)
            .then((res) => {
                this.availableTimeSlots = this.sdtsService.getData(res);
                this.generateTimeSlots();
                this.loading = false;
                console.log('Successfully got Data');
            })
            .catch((err) => {
                this.loading = false;
                console.error('Error loading Data:', err);
            });
    }

    generateTimeSlots(): any[] {
        try {
            this.timeSlotsUI = [];
            this.maxSlotsCount = Math.max(...this.availableTimeSlots.map(day => day.slots.length));
            // Iterate over availableSlots
            for (const Aslot of this.availableTimeSlots) {
            
               const uiSlots = []
                for (const slot of Aslot.slots) {
                    
                    const slotUi = new SlotUI(slot);
              
                    // Push formatted time and status into timeSlotsUI
                    uiSlots.push(slotUi);
                }
                const currentLength = uiSlots.length;
                for (let i = currentLength; i < this.maxSlotsCount; i++) {
                    const emptyUiSlot:SlotUI = new SlotUI();
                    emptyUiSlot.time = '--';
                    emptyUiSlot.available = false;
                    emptyUiSlot.status = '';
                    emptyUiSlot.uuid = 'N/A';
                    uiSlots.push(emptyUiSlot);
                }

                // const date = new Date(Aslot.date.replace('Z', '')); // Remove 'Z' to treat as local time
                const date = new Date(Aslot.date);
                const dayName = date.toLocaleString('en-US', { weekday: 'short' }); // e.g., Sun
                const dayNum = date.getDate(); // e.g., 25

                this.timeSlotsUI.push({slots:uiSlots, date:Aslot.date, day:dayName, dateDay:dayNum});
            }

            this.weekSlots = this.timeSlotsUI
           
            // this.allBooked = this.areAllSlotsBooked();

            // Return the timeSlotsUI array
            return this.timeSlotsUI;
        } catch (err) {
            console.error('Error generating time slots:', err);
            // Return an empty array in case of error
            return [];
        }
    }

    onNextClick(slot: SlotUI, stepper) {
        this.selectedSlot = slot;
        this.goToNextStep(stepper);
    }

    onTimeSlotClick(slot: SlotUI) {
        this.slot_form.patchValue({ selectedSlot: slot });
        this.selectedSlot = slot;
        this.bookingData.scheduledSession.appointment_start_time = slot.Utc_date_time
        this.bookingData.scheduledSession.session_time_slot_uuid =
            slot.uuid;
    }

    /**
     * Form stepper previous
     */
    goToPreviousStep(stepper: MatStepper) {
        stepper.previous();
    }

    /**
     * Form stepper next
     */
    goToNextStep(stepper: MatStepper) {
        stepper.next();
    }

    isFirstStep(stepper: MatStepper) {
        const firstIndex = stepper.selectedIndex == 0;
        return firstIndex;
    }

    isLastStep(stepper: MatStepper) {
        const lastIndex = stepper.selectedIndex == 2;
        return lastIndex;
    }

    saveBooking() {
         this.isLastIndex = this.bookingStepsCount -1 == this.stepper.selectedIndex; 

        if(!this.validateIntakeForm() &&  this.isLastIndex){
           return
        }

        if (this.personal_details_form.invalid || this.slot_form.invalid) {
            this._snackBarService.dangerSnackbar('Please fill all client fields');
            this.loading = false;
            return;
        }

        if (this.bookingSteps.payment && !this.isPaymentFormValid && this.isLastIndex) {
            this._snackBarService.dangerSnackbar('Please enter correct card information');
            this.loading = false;
            return;
        }

        this.setReactiveFormData();
        this.bookingData.scheduledSession.timezone = this.selectedTimeZone?.value || this.getlocalZone();
        this.bookingData.scheduledSessionFormQuestions.formData = this.model;
        this.bookingData.scheduledSessionPayment = this.bookingSteps.payment && this.isLastIndex? this.bookingData.scheduledSessionPayment: null;

        this.bookingData.scheduledSession.status = this.isLastIndex ? 'Active':'Incomplete';
            
        const payload: bookingSavePayload = {
            scheduledSession: this.bookingData.scheduledSession,
            scheduledSessionFormQuestions: this.stepper.selectedIndex !=1 ? this.bookingData.scheduledSessionFormQuestions : null,
            scheduledSessionPayment: this.bookingData.scheduledSessionPayment
        };

        this.loading = true;
        this._bookingService
            .saveBooking(payload)
            .then((res) => {
                const obj :bookingSuccessResponse = this._bookingService.getData(res);
                this.stepper.next();
                this.bookingSuccess = this.isLastIndex;
                this.bookingSuccessInput.bookingdata = obj.scheduledSession;
                this.bookingSuccessInput.bookingdata.appointment_start_time = payload.scheduledSession.appointment_start_time;
                this.bookingData.scheduledSession.uuid = obj.scheduledSession.uuid;
                this.bookingSuccessInput.bookingduration = this.bookingPage.accountSession.duration;
                this.bookingSuccessInput.id = this.bookingPage.accountSession.uuid;
                if (obj?.scheduledSessionFormQuestions?.formData) {
                    this.model = obj.scheduledSessionFormQuestions.formData;
                }
                this.hideBooking = this.isLastIndex;
                this.loading = false;
                this.spinner = false;
            })
            .catch((error) => {
                console.log(error);
                this.loading = false;
                this.spinner = false;

            });
    }

    setMinDatePicker() {
        this.minDate = this.getTodayDate();
    }

    async setPaymentDetails({ vgsForm, vgsState }) {
        (this.vgsForm = vgsForm), (this.vgsState = vgsState);
        this.submitCCInfoToVgs();
    }

    getTodayDate(): NgbDateStruct {
        const today = new Date();
        const todayDateStruct: NgbDateStruct = {
            year: today.getFullYear(),
            month: today.getMonth() + 1,
            day: today.getDate(),
        };

        return todayDateStruct;
    }

    getSelectedDateValue(): NgbDateStruct {
        return this.slot_form.get('calenderSelectedDate')?.value;
    }

    getTimeZoneValue(): TimeZone {
        return this.slot_form.get('timeZoneOffSet')?.value;
    }

    isFormsValid() {
        return this.slot_form.valid && this.personal_details_form.valid;
    }

    getlocalZone(): string {
        const offset = new Date().getTimezoneOffset();
        const hours = Math.floor(Math.abs(offset) / 60);
        const minutes = Math.abs(offset) % 60;

        // Determine the sign: "-" if the offset is positive (behind UTC), "+" if negative (ahead of UTC)
        const sign = offset > 0 ? '-' : '+';

        // Format hours and minutes with leading zeros
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');

        return `${sign}${formattedHours}:${formattedMinutes}`;
    }

    getLocalZoneTitle(): string {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    getAccountData() {
        this._accountService
            .getAccount(this.bookingPage.accountSession.account_uuid)
            .then((res) => {
                this.accountData = this._accountService.getData(res);
                this._eventService.onAccountLoad.emit(
                    this.accountData.account_name
                );
            })
            .catch((error) => {
                console.log(error);
            });
    }

    phoneForm = new FormGroup({
        phone: new FormControl(undefined, [Validators.required]),
    });

    changePreferredCountries() {
        this.preferredCountries = [
            CountryISO.UnitedStates,
            CountryISO.Canada,
            CountryISO.Mexico,
        ];
    }

    isInvalidPhoneNumber(): boolean {
        return this.personal_details_form
            .get('phone')
            .hasError('validatePhoneNumber');
    }

    isEmptyPhoneNumber(): boolean {
        return this.personal_details_form.get('phone').hasError('required');
    }

    emitPayment() {
        this.loading = true;
        this._cdr.detectChanges()
        this._eventService.onBookClick.emit();
    }

    submitVgsForm() {
        return new Promise((resolve, reject) => {
            this.vgsForm.submit(
                '/api/cards/persistent',
                {},
                (status, data) => {
                    if (status === 200) {
                        resolve(data);
                    }
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }

    setDataOfCreditCard(data) {
        const exp = data.exp_date.replace(/\s+/g, '');

        if (data) {
            this.payment.cvv_code = data.cvv_code;
            this.payment.exp_date = exp;
            this.payment.card_number = data.card_number;
            this.payment.card_type = this.vgsState.card_number.cardType;
            this.payment.zip_code = data.zip_code;
            this.payment.cardholder_name = data.cardholder_name;
            this.payment.last_four_digit = this.vgsState.card_number.last4;
            this.isPaymentFormValid = true;
            this.bookingData.scheduledSessionPayment =
                this.payment;

            this.saveBooking();
            return;
        }
        this.showPaymentError();
    }
   
    async submitCCInfoToVgs() {
        Object.values(this.vgsForm.state).every((field: any, i) => {
            if (!field.isValid) {
                this.loading = false;
                this.showPaymentError(field);
                return false;
            }
            if (i === 4) {
                this.submitVgsForm()
                    .then((res) => {
                        this.setDataOfCreditCard(res);
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.showPaymentError();
                    });
            }
            return true;
        });

    }

    showPaymentError(field = null) {
        if (field) {
            field.errorMessages.forEach((message: string) => {
                const title = this.util.toTitleCase(field.name);
                this._snackBarService.dangerSnackbar(`${title} ${message}`);
            });
        } else {
            this._snackBarService.dangerSnackbar(
                'Please enter correct card information'
            );
        }
        this.loading = false;
    }

    areAllSlotsBooked(): boolean {
        // try {
        //     // Check if all slots have a status of "Booked"
        //     return this.timeSlotsUI.every(
        //         (slot: NewSlotUi) => slot.st === 'Confirmed'
        //     );
        // } catch (err) {
        //     console.error('Error checking if all slots are booked:', err);
        //     return false; // Return false in case of an error
        // }

        return false
    }
 
    validateIntakeForm():boolean {
        if(!this.bookingSteps.intake){
            return true;
        }
        const isValidForm = this.dynamicForm?.form?.valid;
        this.dynamicForm?.formGroup?.markAllAsTouched()
        if(isValidForm){
            this.intake_form.patchValue({ validated: true }); // Set dummy field to make form valid
            this.intake_form.markAsPristine();
            this.intake_form.markAsUntouched();
            this.intake_form.updateValueAndValidity();
            return true
        }
        
        if(this.stepper.selectedIndex == 2){
        this.intake_form.patchValue({ validated: null }); // Set dummy field null to make form invalid
        const snackbarRef = this._snackBarService.errorSnackbar('Please fill all Intake form fields correctly');
        setTimeout(() => {
            snackbarRef.dismiss();
          }, 2000);
          
        this.loading = false;
        }
        return false
    }

    setBookingSteps(){
        this.bookingSteps.payment =  this.bookingPage.accountSession.amount > 0;
        this.bookingSteps.intake = this.bookingPage?.sessionFormQuestions?.formData ? true : false;
        this.bookingStepsCount = Object.values(this.bookingSteps).filter(Boolean).length;
    }

    onSubmitClick(){
        if(this.bookingSteps.payment){
            this.emitPayment()
        }else{
            this.saveBooking()
        }
    }

    public executeRecaptchaV3() {
        this.loading = true;
		this.subs = this.recaptchaV3Service.execute('onSchedulerPaymentSubmit').subscribe(
		  (token) => {
			if(token) {
				this.captchaResponse = token;
				this.captchaSuccess = true;
                this.reCapchaVerify(token);
			} else {
                this.loading = false;
				this._snackBarService.warnSnackbar("Captcha verification failed, please try again or contact support for further assistance. Verification Failed");
			}
		  },
		  (error) => {
             this.loading = false;
			this._snackBarService.warnSnackbar("Captcha verification failed, please try again or contact support for further assistance. Verification Failed");
			console.log(`Recaptcha v3 error:`, error);
		  }
		);
	  }

    goNext(stepper:MatStepper){
        if(stepper.selectedIndex == 2 && this.bookingSteps.intake){
           if(this.validateIntakeForm()) this.saveBooking();  //step 3 -Save intake form
        } else if (this.personal_details_form.invalid || this.slot_form.invalid && stepper.selectedIndex == 1) stepper.next(); //step 2 -Validate personal details form
          // step 2 - Save personal details form
            else this.saveBooking();
    }

    bookingPageLoadErrorHandler(error = "Not Found") {
        console.error('Error fetching Booking Page:', error);
        this.error = 'Not Found';
        this.hideBooking = true;
        this.loading = false;
    }

    setDynamicFormData() {
        const formdata: any = this.bookingPage?.sessionFormQuestions?.formData;
        if (formdata) {
            const parsedForm = JSON.parse(formdata);
            this.definition = this.util.createDynamicFormDefinition(parsedForm);
        }
    }

    setPhoneFields(){
       
    }

    onPreviousDayClick(){
        this.onDateSelect('prev')
    }

    setReactiveFormData(){

        const phone = this.personal_details_form.value.phone;
        const countryCode = phone.countryCode;
        const number = phone.number;
        this.bookingData.scheduledSession.phone_country_code = countryCode;
        this.bookingData.scheduledSession.phone_no = number
        
        const personal_form = this.personal_details_form.value
        this.bookingData.scheduledSession.client_first_name = personal_form.clientFirstName;
        this.bookingData.scheduledSession.client_last_name = personal_form.clientLastName;
        this.bookingData.scheduledSession.client_email = personal_form.clientEmail;
        this.bookingData.scheduledSession.notes = personal_form.notes;
    }

    reCapchaVerify(token){
        let data = {value:token, uuid : this.bookingPageId}
        this.lawpayService.verifyReCaptcha(data).then((res)=>{
          let data = this.lawpayService.getData(res);
          this.isLastIndex = true;
          this.onSubmitClick();

        }).catch((error)=>{
             this.loading = false;
            console.log(error);
        })
      }

}
